import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Package } from "@/types/Package";

interface PackagesState {
    packages: Package[];
    loading: boolean;
    error: string | null;
}

const initialState: PackagesState = {
    packages: [],
    loading: false,
    error: null,
};

const packagesSlice = createSlice({
    name: "packages",
    initialState,
    reducers: {
        // Add a new package to the state array
        addPackage(state, action: PayloadAction<Package>) {
            state.packages.push(action.payload);
        },

        // Remove an existing package by id
        removePackage(state, action: PayloadAction<number>) {
            state.packages = state.packages.filter(
                (pkg) => pkg.id !== action.payload
            );
        },

        // Update an existing package by matching on id
        updatePackage(state, action: PayloadAction<Package>) {
            const updated = action.payload;
            const index = state.packages.findIndex((pkg) => pkg.id === updated.id);
            if (index !== -1) {
                state.packages[index] = updated;
            }
        },

        setPackages(state, action: PayloadAction<Package[]>) {
            state.packages = action.payload;
        },

        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },

        setError(state, action: PayloadAction<string | null>) {
            state.error = action.payload;
        },
    },
});

export const {
    addPackage,
    removePackage,
    updatePackage,
    setPackages,
    setLoading,
    setError,
} = packagesSlice.actions;
export default packagesSlice.reducer;
